import { render, staticRenderFns } from "./content-group.vue?vue&type=template&id=2feefef8&scoped=true"
import script from "./content-group.vue?vue&type=script&lang=js"
export * from "./content-group.vue?vue&type=script&lang=js"
import style0 from "./content-group.vue?vue&type=style&index=0&id=2feefef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feefef8",
  null
  
)

export default component.exports